import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";
import { isbnsData } from "./ISBNSReducer";

export interface eanObj {
  _id: string;
  EAN: number;
  Title: string;
}

interface ean {
  eans?: isbnsData[];
  status?: number;
  message?: string;
  page: number;
  limit: number;
  searchStr: string;
  eanScrollPosition: number;
  isLoading: boolean;
  isbnHasMore: boolean;
}

interface newIsbnState {
  message?: string;
  err?: string;
  status?: string;
  eans: ean;
  // eanSelectedValue?:eanInterface
}

const initialState: newIsbnState = {
  err: "",
  status: "",
  message: "",
  eans: {
    eans: [],
    isLoading: false,
    status: 0,
    message: "",
    page: 1,
    limit: 10,
    searchStr: "",
    eanScrollPosition: 0,
    isbnHasMore: true,
  },
  // eanSelectedValue:{
  //   _id:"",
  //   EAN:0,
  //   Title:"",
  // },
};

export const fetchEans = createAsyncThunk(
  "ean/fetchEans",
  async (
    data: {
      searchStr: string;
      page: number;
      limit: number;
      oldEans: any;
      selectedEans?: any;
      type?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      if (data.searchStr) {
        data.page = 1;
      }
      const response = await axios.post(API.FETCHEANS, data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

export const newEANSlice = createSlice({
  name: "ean",
  initialState,
  reducers: {
    resetEanPage: (state) => {
      state.eans.page = initialState.eans.page;
    },
    updateEanSearchStr: (state, action) => {
      state.eans.searchStr = action.payload;
    },
    updateEanPage: (state) => {
      state.eans.page += 1;
    },
    updateEanScrollPosition: (state, action) => {
      state.eans.eanScrollPosition = action.payload;
    },
    // updateSearchStr:(state,action) => {
    //   state.eans.searchStr = action.payload;
    // },
    emptyEansScrollPosition: (state) => {
      state.eans.eanScrollPosition = initialState.eans.eanScrollPosition;
    },
    // updateEanSelectedValue:(state,action) => {
    //   state.eanSelectedValue = action.payload;
    // },
    emptyEansValue: (state) => {
      // state.eanSelectedValue = initialState.eanSelectedValue;
      state.eans = initialState.eans;
      state.err = initialState.err;
      state.message = initialState.message;
      state.status = initialState.status;
    },

    setEansLoading:(state,action)=>{
      state.eans.isLoading = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEans.pending, (state) => {
        state.eans.isLoading = true;
      })
      .addCase(fetchEans.fulfilled, (state, action: PayloadAction<any>) => {
        state.eans.isLoading = false;
        state.eans.isbnHasMore = action.payload.data.hasMore;

        const filteredISBNs = action.payload.data?.data?.filter(
          (isbn: any) =>
            !state.eans.eans
              ?.map((stateIsbn) => stateIsbn._id)
              .includes(isbn._id)
        );

        console.log("filteredISBNs24235", filteredISBNs);

        if (filteredISBNs.length > 0) {
          if (state.eans.eans && state.eans.page > 1)
            action.payload.data?.data?.length &&
              state.eans.eans.push(...filteredISBNs);
          else if (state.eans.page === 1) state.eans.eans = filteredISBNs;
        }
      })
      .addCase(fetchEans.rejected, (state, action: PayloadAction<any>) => {
        state.eans.isLoading = false;
        state.eans.status = action.payload.status;
      });
  },
});

export const {
  updateEanPage,
  updateEanSearchStr,
  updateEanScrollPosition,
  emptyEansScrollPosition,
  // updateEanSelectedValue,
  emptyEansValue,
  resetEanPage,
  setEansLoading
} = newEANSlice.actions;

export default newEANSlice.reducer;
